import { Grid } from '@material-ui/core'
import { MdAccessTime } from 'react-icons/md'
import Modal from 'shared/components/Modal'
import { colors } from 'shared/styles/colors'
import {
  ContainerIcon,
  StyledCancelButton,
  Message,
  StyleButton,
} from './styles'
import ISendSmsImpl from 'modules/lotesSolicitados/domain/usecases/SendSmsImpl'
import { registerEvent } from 'shared/services/TrackingGAService'
import { phoneMask } from 'shared/utils/formatters'
import { useHistory } from 'react-router-dom'
import { ELockOCMessageTypes } from '../../utils/ELockOCMessage'

type TProps = {
  openModal?: boolean
  setAlertType?: (arg0: ELockOCMessageTypes) => void
  sendSms: ISendSmsImpl
  loteId: number
  telefone?: string
}

const ModalAguardandoValidacao: React.FC<TProps> = ({
  openModal,
  loteId,
  setAlertType,
  sendSms,
  telefone,
}) => {
  const history = useHistory()
  const handleNotifyBySms = async () => {
    try {
      await sendSms.execute(loteId, true)
      registerEvent({
        categoria: 'Tagueamento de Sms',
        acao: 'Aceitar ser notificado por SMS',
        local: 'Botao sim na modal de lotes',
      })
      setAlertType(ELockOCMessageTypes.WAIT_FOR_NOTIFICATION)
      history.push('/lotes-solicitados')
    } catch (e) {
      console.error(e)
    }
  }

  const handleDontNotifyBySms = async () => {
    try {
      await sendSms.execute(loteId, false)
      registerEvent({
        categoria: 'Tagueamento de Sms',
        acao: 'Não ser notificado por SMS',
        local: 'Botao não na modal de lotes',
      })
      setAlertType(ELockOCMessageTypes.NENHUM)
      history.push('/lotes-solicitados')
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <Modal
        openModal={openModal}
        size={'small'}
        showCloseButton={true}
        onCloseModal={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      >
        <Grid
          md={12}
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          style={{ textAlign: 'center', height: '100%' }}
        >
          <Grid container alignItems="center" justify="center" spacing={4}>
            <Grid item>
              <ContainerIcon>
                <MdAccessTime fontSize={40} color={colors.blue} />
              </ContainerIcon>
            </Grid>
          </Grid>

          <Grid container item>
            <Message
              dangerouslySetInnerHTML={{
                __html: `Essa viagem está <b>aguardando aprovação</b> do time de operações.<br/>Deseja ${
                  telefone
                    ? `ser notificado via SMS através do número ${phoneMask(
                        telefone,
                      )}`
                    : 'notificar o solicitante da carga via SMS'
                } quando a carga alterar de status?`,
              }}
            />
          </Grid>

          <Grid container alignItems="center" justify="center" item>
            <StyledCancelButton onClick={handleDontNotifyBySms}>
              Não
            </StyledCancelButton>

            <StyleButton color={colors.green} onClick={handleNotifyBySms}>
              Sim
            </StyleButton>
          </Grid>
        </Grid>
      </Modal>
    </>
  )
}

export default ModalAguardandoValidacao
